import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { ThumbsUp, MessageCircle } from 'lucide-react';

const ConversationActionsCard = ({ onHelped, onContinue, isClosing }) => {
  return (
    <Card className="card-surface border-[#8B5CF6] bg-[#8B5CF6] bg-opacity-10" data-testid="conversation-actions-card">
      <CardContent className="p-6">
        <h3 className="text-lg font-semibold text-[#F9FAFB] mb-4 text-center" style={{ fontFamily: 'Outfit' }}>How do you feel now?</h3>
        <div className="grid sm:grid-cols-2 gap-4">
          <Button
            onClick={onHelped}
            disabled={isClosing}
            className="btn-gold rounded-full py-6 text-base font-semibold flex items-center justify-center gap-2"
            data-testid="im-helped-button"
          >
            <ThumbsUp className="w-5 h-5" />
            {isClosing ? 'Closing...' : "Thanks, I've Been Helped!"}
          </Button>
          <Button
            onClick={onContinue}
            variant="outline"
            className="rounded-full py-6 text-base font-semibold border-[#8B5CF6] text-[#8B5CF6] hover:bg-[#8B5CF6] hover:text-white flex items-center justify-center gap-2"
            data-testid="continue-talking-button"
          >
            <MessageCircle className="w-5 h-5" />
            I Need to Keep Talking
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default ConversationActionsCard;
